import { ISwAppInvoicesApi } from "../../interfaces-and-types";

type TInvoicesUrls = {
  [key in keyof ISwAppInvoicesApi]: string;
};

const rootInvoicesUrl = "/invoices";

export const invoicesUrls: TInvoicesUrls = {
  // createInvoice: `${rootInvoicesUrl}`,
  getInvoices: `${rootInvoicesUrl}`,
  getInvoiceById: `${rootInvoicesUrl}/id`,
  // editInvoice: `${rootInvoicesUrl}/id`,
  deleteInvoice: `${rootInvoicesUrl}/id`,
};
